import { Audio, Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SnowLayer from '../items/SnowLayer';
import { centerSprite, enableUserClick } from '../phaserHelpers';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import GameplayScene from './GameplayScene';

export default class TitleScene extends Phaser.Scene
{
    static get KEY() { return 'TitleScene'; }

    create()
    {
        const ss = Images.DEFAULT_ATLAS;
        this.bg = this.add.sprite(0,0, ss, "Background").setOrigin(0);

        if(!this.sound.title)
        {
            this.sound.title = Audio.createSound(this);
            this.sound.title.play(SoundAssetKeys._Ornament_Puzzle, {loop: true});
        }

        this.snowGroup = this.add.group();
        this.backSnow = new SnowLayer(this, 0, 0, this.atlasId);
        this.ornament = this.add.sprite(this.scale.width/2,320,ss,"TitleOrnament").setOrigin(0);
        this.titleBackdrop = this.add.sprite(this.scale.width/2,348,ss,"TitleOrnamentTextBg").setOrigin(0);
        this.titleBackdrop.x = this.scale.width/2-this.titleBackdrop.width/2;
        this.titleBackdrop.y = 348-this.titleBackdrop.height/2;
        this.lblTitle = this.add.sprite(this.scale.width/2,348,ss, "LABEL_Title").setOrigin(0);

        this.snowBank = this.add.sprite(0,0,ss, "FrontSnowbank").setOrigin(0);
        this.snowBank.y = this.scale.height-this.snowBank.height;

        this.btnStart = this.add.sprite(this.scale.width/2-3,708,ss,"BUTTON_Play").setOrigin(0);

        centerSprite([this.ornament, this.lblTitle, this.btnStart]);

        this.btnStart.scaleX = 0;
        this.btnStart.scaleY = 0;

        this.snowGroup.add(this.backSnow);
        this.backSnow.startFill();

        this.sLeft = this.ornament.x - this.ornament.width/2-3;//-3 just to give a bit advance
        this.lblPlusRight = this.lblTitle.width/2;

        this.fullBackWidth = this.titleBackdrop.width;
        this.backdropRect = new Phaser.GameObjects.Rectangle(this, 0, 0, 0, this.titleBackdrop.height);
        this.titleBackdrop.setCrop(this.backdropRect);

        Tweens.addTween(this.ornament, 1800, {y:{start: -this.ornament.height, to: this.ornament.y}, easeParams: [1, 0.3]}, Phaser.Math.Easing.Elastic.Out);

        let tween = Tweens.addTween(this.lblTitle, 2100, {x: {start: -this.lblTitle.width*0.5, to: this.lblTitle.x}, easeParams: [1, 0.3], delay: 1680}, Phaser.Math.Easing.Elastic.Out);
        tween.on('update', ()=>this.titleComingIn());
        tween.on('complete', ()=>this.titleFinished());
    }

    titleComingIn() {
        const titleRight = this.lblTitle.x + this.lblPlusRight;
        if (titleRight > this.sLeft) {
            const amt = titleRight - this.sLeft;
            this.backdropRect.width = amt;
            this.titleBackdrop.setCrop(this.backdropRect);
        }
    };

    titleFinished(){
        this.backdropRect.width = this.fullBackWidth;
        this.titleBackdrop.setCrop(this.backdropRect);
        enableUserClick(this.btnStart, this.clickStart, this);
        Tweens.addTween(this.btnStart, 800, {scaleX: 1, scaleY: 1, easeParams: [1, 0.3]}, Phaser.Math.Easing.Elastic.Out);
    };

    clickStart() {
        Audio.playOneShot(SoundAssetKeys._click_Copy, this);
        this.btnStart.disableInteractive()
        this.scene.start(GameplayScene.KEY);
    };
}